import React, { useContext, useEffect, useState } from 'react';
import DashBoardPageHeaderPage from '../components/DashBoard/DashBoardHeaderPage';
import {
  Stack,
  Table,
  styled,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Paper,
  TableRow,
  Typography,
  TablePagination,
  Box,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  Button,
  Divider,
  DialogContent,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { get, put, post } from '../services/apiMethods';
import URLS from '../services/urlConstants';
import WarehouseContext from '../context/WarehouseContext';
import { downloadExcel, ROWS_PER_PAGE } from '../utils/utilities';
import { Download } from '@mui/icons-material';
import CustomSelectVirtualized from '../components/SecondaryForms/CustomSelectVirtualized';
import dayjs from 'dayjs';
import CustomSelect from '../components/SecondaryForms/CustomSelect';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CustomInput from '../components/SecondaryForms/CustomInput';
import ShowComponent from '../components/ShowComponent';
import ViewOrUpdateItemFiles from '../components/ViewOrUpdateItemFiles';
import { PuffLoader } from 'react-spinners';
import RemoveRedEyeRoundedIcon from '@mui/icons-material/RemoveRedEyeRounded';
import { Close } from '@mui/icons-material';
import { toast } from 'react-toastify';

const CustomDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    width: '600px',
    maxWidth: '100%',
    color: '#000',
  },
});

const StyledTableCell = styled(TableCell)(() => ({
  minWidth: '200px',
  whiteSpace: 'nowrap',
  padding: '12px 8px',
  fontSize: '0.875rem',
}));

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  '& .MuiTableCell-root': {
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.light,
    color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black,
    fontWeight: 600,
    position: 'sticky',
    top: 0,
    zIndex: 1,
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
}));

const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: 'calc(100vh - 300px)',
  '& .MuiTable-root': {
    borderCollapse: 'separate',
    borderSpacing: 0,
  },
  '& .MuiTableRow-root:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:hover': {
    backgroundColor: theme.palette.action.selected,
  },
}));

const getModifiedStyles = isModified => ({
  fontWeight: isModified ? 'bold' : '',
  fontSize: isModified ? '12px' : '',
  backgroundColor: isModified ? '#8c8a50' : '',
  color: isModified ? 'white' : '',
});

export default function AllItemHistory() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { selectedWarehouse, selectedOwnerCode, selectedOwnerGroup } = useContext(WarehouseContext);
  const [msn, setMsn] = useState('');
  const [allMsns, setAllMsns] = useState([]);
  const [formData, setFormData] = useState([]);
  const [itemFormFields, setItemFormFields] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const [updateData, setUpdateData] = useState(null);
  const [stockTypes, setStockTypes] = useState([]);
  const [subFamilies, setSubFamilies] = useState([]);
  const [storageCodes, setStorageCodes] = useState([]);
  const [palletCodes, setPalletCodes] = useState([]);
  const [currentConditionCodes, setCurrentConditionCodes] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [damageCode, setDamageCode] = useState([]);
  const [activityCodes, setActivityCodes] = useState([]);
  const [packaging, setPackaging] = useState([]);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gradingScale, setGradingScale] = useState([]);
  const [itemDescription, setItemDescription] = useState([]);
  const [open, setOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [isModifiedImage, setIsModifiedImage] = useState();
  const [orderTypeData, setOrderTypeData] = useState([]);
  const [itemWarehose, setItemWarehouse] = useState(null);
  const theme = useTheme();
  let fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [isSuper, setIsSuper] = useState(false);

  useEffect(() => {
    const jsonEmployee = window.localStorage.getItem('current_inventory_user');
    if (jsonEmployee && JSON.parse(jsonEmployee) && JSON.parse(jsonEmployee)?.role === 'super') {
      setIsSuper(true);
    }
  }, []);

  const handleOpen = images => {
    try {
      let parsedImages = [];
      if (images?.value) {
        if (typeof images.value === 'string') {
          try {
            // First, try to extract just the array part before any "Previous" text
            let cleanValue = images.value.split('- Previous')[0].trim();

            // Remove any trailing commas or invalid characters
            cleanValue = cleanValue.replace(/,\s*$/, '');

            // Ensure the string is properly formatted as a JSON array
            if (!cleanValue.startsWith('[')) {
              cleanValue = `[${cleanValue}]`;
            }
            if (!cleanValue.endsWith(']')) {
              cleanValue = `${cleanValue}]`;
            }

            // Parse the JSON array
            const parsedArray = JSON.parse(cleanValue);
            // Ensure we have an array of strings
            parsedImages = Array.isArray(parsedArray) ? parsedArray : [parsedArray];
          } catch (e) {
            console.error('Error parsing images:', e);
            // If parsing fails, try to extract URLs using regex
            const urlRegex = /(https?:\/\/[^\s"]+)/g;
            const matches = images.value.match(urlRegex);
            parsedImages = matches || [];
          }
        } else {
          parsedImages = Array.isArray(images.value) ? images.value : [images.value];
        }
      }
      setImages(parsedImages);
      setIsModifiedImage(images?.isModified);
      setOpen(true);
    } catch (error) {
      console.error('Error in handleOpen:', error);
      setImages([]);
      setOpen(true);
    }
  };
  const handleClose = () => setOpen(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getItemFormDetails = async () => {
    try {
      const { data } = await get(URLS.forms.list, {
        params: {
          collectionName: 'item',
          warehouse: itemWarehose,
        },
      });
      setItemFormFields(data.result ? data.result[0]?.fields : []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMsnChange = e => {
    setMsn(e.target.value);
  };

  const handleFindHistory = async e => {
    if (e) {
      e.preventDefault();
    }
    try {
      setLoading(true);
      const { data } = await get(URLS.itemHistory.read + '/' + msn);
      setFormData(data.result.detailedHistory || []);

      if (data.result) {
        const newUpdateData = data.result.itemDetails;

        setUpdateData({
          _id: newUpdateData?._id,

          warehouse: newUpdateData.warehouse?._id,
          itemCategory: newUpdateData.itemCategory,
          enteredDate: newUpdateData.inboundEnteredDate,
          expiryDate: newUpdateData.expiryDate,
          stockType: newUpdateData.stockType?._id,
          orderType: newUpdateData.orderType?._id,
          msn: newUpdateData.msn,
          subFamily: newUpdateData.subFamily?._id,
          itemDescription: newUpdateData.itemDescription,
          itemCode: newUpdateData.itemCode,
          manufacturerPartNumber: newUpdateData.manufacturerPartNumber,
          brandName: newUpdateData.brandName?._id,
          storageCode: newUpdateData.storageCode?._id,
          palletCode: newUpdateData.palletCode?._id,
          conditionCode: newUpdateData.conditionCode?._id,

          gradingScale: newUpdateData.gradingScale ? newUpdateData.gradingScale?._id : null,

          activityCode: newUpdateData.activityCode ? newUpdateData.activityCode?._id : null,

          damageCode: newUpdateData.damageCode ? newUpdateData.damageCode?._id : null,
          packaging: newUpdateData.packaging ? newUpdateData.packaging?._id : null,
          configurationOs: newUpdateData.configurationOs,
          remarks: newUpdateData.remarks,
          warehouseRemarks: newUpdateData.warehouseRemarks,
          oemCaseNumber: newUpdateData.oemCaseNumber,
          rmaActivityWhRemarks1: newUpdateData.rmaActivityWhRemarks1,
          rmaActivityWhRemarks2: newUpdateData.rmaActivityWhRemarks2,
          oemSupportRemarks: newUpdateData.oemSupportRemarks,
          callLogDate: newUpdateData.callLogDate,
          oemRepairDate: newUpdateData.oemRepairDate,
          serviceReportReceivedDate: newUpdateData.serviceReportReceivedDate,
          quotationReceivedDate: newUpdateData.quotationReceivedDate,
          images: newUpdateData.images,

          meta: itemFormFields?.map(f => ({
            ...f,
            value: newUpdateData.meta?.find(fi => fi.inputLabel === f.inputLabel)?.value || '',
          })),
        });
        setItemWarehouse(newUpdateData.warehouse?._id);
      } else {
        setUpdateData(null);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (msn) {
      handleFindHistory();
    }
  }, [msn, itemFormFields]);

  const getData = async () => {
    try {
      const stockPromise = get(URLS.stockType.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });
      const subFamilyPromise = get(URLS.subFamily.list, {
        params: { warehouse: { $in: selectedWarehouse } },
      });
      const itemDescriptionPromise = get(URLS.itemDescription.getItemDescription, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });
      const storageCodePromise = get(URLS.storageCode.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });
      const palletCodeCodePromise = get(URLS.palletCode.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });
      const currentConditionCodePromise = get(URLS.conditionCode.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });

      const brandDataPromise = get(URLS.brand.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });

      const gradingScallePromise = get(URLS.gradingScale.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });
      const packagingPromise = get(URLS.packaging.list, {
        params: { warehouse: { $in: selectedWarehouse } },
      });
      const damageCodePromise = get(URLS.damageCode.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });
      const activityCodePromise = get(URLS.currentActivityCode.list, {
        params: { search: { warehouse: { $in: selectedWarehouse } } },
      });
      const orderTypeDataPromise = get(URLS.orderType.list, {
        params: { warehouse: { $in: selectedWarehouse } },
      });

      const [
        stockTypeData,
        subFamilyData,
        itemDescriptionData,
        storageCodeData,
        palletCodeData,
        currentConditionCodeData,
        gradingScaleData,
        packagingData,
        damageCodeData,
        brandData,
        activityCodeData,
        orderTypeData,
      ] = await Promise.all([
        stockPromise,
        subFamilyPromise,
        itemDescriptionPromise,
        storageCodePromise,
        palletCodeCodePromise,
        currentConditionCodePromise,
        gradingScallePromise,
        packagingPromise,
        damageCodePromise,
        brandDataPromise,
        activityCodePromise,
        orderTypeDataPromise,
      ]);

      setActivityCodes(
        activityCodeData?.data?.result.map(w => ({
          ...w,
          label: `${w.code}-${w.description}`,
          value: w._id,
        }))
      );

      setBrandData(
        brandData?.data?.result.map(w => ({
          ...w,
          label: w.name,
          value: w._id,
        }))
      );

      setStockTypes(
        stockTypeData?.data?.result?.map(s => ({
          ...s,
          label: s.name,
          value: s._id,
        }))
      );

      setSubFamilies(
        subFamilyData.data.result.map(s => ({
          ...s,
          label: s.name,
          value: s._id,
        }))
      );
      setItemDescription(
        itemDescriptionData.data.result.map(s => ({
          ...s,
          label: s.description,
          value: s.description,
        }))
      );
      setStorageCodes(
        storageCodeData.data.result.map(s => ({
          ...s,
          label: s.code,
          value: s._id,
        }))
      );
      setPalletCodes(
        palletCodeData.data.result.map(s => ({
          ...s,
          label: s.code,
          value: s._id,
        }))
      );
      setCurrentConditionCodes(
        currentConditionCodeData.data.result.map(s => ({
          ...s,
          label: `${s.code}-${s.description}`,
          value: s._id,
        }))
      );
      setGradingScale(
        gradingScaleData?.data?.result?.map(s => ({
          ...s,
          label: `${s.name}-${s.description}`,
          value: s._id,
        }))
      );
      setPackaging(
        packagingData.data.result.map(s => ({
          ...s,
          label: s.title,
          value: s._id,
        }))
      );

      setDamageCode(
        damageCodeData.data.result.map(s => ({
          ...s,
          label: `${s.code}-${s.description}`,
          value: s._id,
        }))
      );
      setOrderTypeData(
        orderTypeData?.data?.result.map(o => ({
          ...o,
          label: o.name,
          value: o._id,
        }))
      );
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getData();
  }, [selectedWarehouse]);

  const getAllItems = async () => {
    try {
      const { data } = await get(URLS.items.getItemsForHistory, {
        params: {
          warehouses: selectedWarehouse,
          ownerCodes: selectedOwnerCode,
          ownerGroups: selectedOwnerGroup,
          // search: { itemCategory: { $ne: "faulty" } },
        },
      });

      setAllMsns(data.result.map(d => ({ label: d.msn, value: d._id })));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setFormData([]);
    setUpdateData(null);
    getAllItems();
  }, [selectedWarehouse, selectedOwnerCode, selectedOwnerGroup]);

  useEffect(() => {
    if (itemWarehose) getItemFormDetails();
  }, [itemWarehose]);

  const handleDownloadHistory = async () => {
    try {
      if (!msn) return;
      setDownloading(true);
      const { data } = await post(
        URLS.itemHistory.downloadHistory,
        { itemIds: [msn] },
        {
          responseType: 'blob',
        }
      );
      setDownloading(false);

      downloadExcel(data, `Item-history-${msn}.xlsx`);
    } catch (error) {
      console.log(error);
      setDownloading(false);
    }
  };

  const handleChange = (e, dateFieldName) => {
    let name, value;

    if (e && e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = dateFieldName || 'expiryDate';
      value = e
        ? e.hour(dayjs().hour()).minute(dayjs().minute()).second(dayjs().second())
        : null;
    }
    setUpdateData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleUpdate = async (id, fd) => {
    try {
      setLoadingSave(true);
      const payload = {
        ...fd,
      };

      let meta = payload.meta;
      if (meta && meta.length) {
        for (let f of meta) {
          if (f.isRequired && !String(f.value)?.trim()) {
            toast.error(`Please fill the required field: ${f.inputLabel}`);
            return setLoadingSave(false);
          }
        }
      }

      let activityCode = activityCodes.find(a => a._id === payload.activityCode);

      let itemCategory = payload.itemCategory?.toLowerCase();

      let grade = gradingScale.find(g => g._id === payload.gradingScale);

      const isDamaged = grade?.isDamaged;
      if (grade && isDamaged) {
        if (!fd.activityCode || !fd.damageCode) {
          toast.error('Please mention activity code and damage code!');
          return setLoadingSave(false);
        } else if (
          (activityCode && activityCode.canBeMovedToStock) ||
          (activityCode && activityCode.showInProcessed)
        ) {
          itemCategory = 'used';
        } else {
          itemCategory = 'faulty';
        }
      } else if (grade && !isDamaged) {
        itemCategory = 'used';
        delete payload.activityCode;
        delete payload.damageCode;
      }

      const { data } = await put(URLS.items.update + '/' + id, {
        ...payload,
        itemCategory: itemCategory,
      });
      handleFindHistory();
      setLoadingSave(false);
    } catch (error) {
      console.log(error);
      setLoadingSave(false);
    }
  };

  const handleCustomInputChangeItem = e => {
    const { name, value } = e.target;

    setUpdateData(prev => ({
      ...prev,
      meta: prev.meta.map(m => (m.inputLabel === name ? { ...m, value } : m)),
    }));
  };

  const onUpdateItem = item => {
    handleFindHistory();
    setUpdateData(prev => ({
      ...prev,
      _id: item._id,

      expiryDate: item.expiryDate,
      warehouse: item.warehouse?._id,
      stockType: item.stockType._id,
      orderType: item.orderType?._id,
      msn: item.msn,
      subFamily: item.subFamily._id,
      itemDescription: item.itemDescription,
      itemCode: item.itemCode,
      manufacturerPartNumber: item.manufacturerPartNumber,
      brandName: item.brandName._id,
      storageCode: item.storageCode._id,
      palletCode: item.palletCode._id,
      conditionCode: item.conditionCode._id,
      damageCode: item.damageCode ? item.damageCode._id : null,
      activityCode: item.activityCode ? item.activityCode._id : null,
      packaging: item.packaging ? item.packaging._id : null,
      configurationOs: item.configurationOs,
      warehouseRemarks: item.warehouseRemarks,
      oemCaseNumber: item.oemCaseNumber,
      rmaActivityWhRemarks1: item.rmaActivityWhRemarks1,
      rmaActivityWhRemarks2: item.rmaActivityWhRemarks2,
      oemSupportRemarks: item.oemSupportRemarks,
      callLogDate: item.callLogDate,
      oemRepairDate: item.oemRepairDate,
      serviceReportReceivedDate: item.serviceReportReceivedDate,
      quotationReceivedDate: item.quotationReceivedDate,
      remarks: item.remarks,
      images: item.images,
      meta: itemFormFields?.map(f => ({
        ...f,
        value: item.meta?.find(fi => fi.inputLabel === f.inputLabel)?.value || '',
      })),
    }));
  };

  const extractFileInfo = url => {
    try {
      // Extract date from URL (format: YYYY-MM-DD)
      const dateMatch = url.match(/\/(\d{4}-\d{2}-\d{2})\//);
      const date = dateMatch ? dateMatch[1] : '';

      // Extract filename from URL
      const filename = url.split('/').pop();

      return {
        date: date ? new Date(date).toLocaleDateString() : 'Unknown date',
        filename: filename || 'Unknown file',
      };
    } catch (error) {
      return {
        date: 'Unknown date',
        filename: 'Unknown file',
      };
    }
  };

  return (
    <>
      <DashBoardPageHeaderPage title="All Items History" />

      <Grid
        container
        component="form"
        onSubmit={handleFindHistory}
        spacing={2}
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Grid item xs={12} md={3}>
          <CustomSelectVirtualized
            onChange={handleMsnChange}
            label="MSN"
            value={msn}
            required={true}
            options={allMsns}
          />
        </Grid>
        {msn ? (
          <Grid item xs={12} md={3} mt={1} alignSelf={'center'}>
            <LoadingButton
              loading={downloading}
              size="small"
              onClick={handleDownloadHistory}
              variant="contained"
              startIcon={<Download fontSize="small" />}
            >
              History
            </LoadingButton>
          </Grid>
        ) : null}
      </Grid>
      {loading ? (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '20px',
            paddingBottom: '20px',
          }}
        >
          <PuffLoader size={30} color="#14532d" />
        </Box>
      ) : null}

      {updateData ? (
        <>
          {' '}
          <Typography component="h1" sx={{ fontWeight: 'bold' }}>
            Item Details
          </Typography>
          {updateData.itemCategory?.toLowerCase() === 'used' ? (
            <>
              {' '}
              <TableContainer component={Paper}>
                <Table>
                  <TableHead
                    sx={{
                      backgroundColor: theme =>
                        theme.palette.mode === 'dark'
                          ? theme.palette.primary.dark
                          : theme.palette.primary.light,
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ minWidth: '80px' }} align="center">
                        S.NO
                      </TableCell>
                      <StyledTableCell align="center">ITEM CATEGORY</StyledTableCell>
                      <StyledTableCell align="center">EXPIRY DATE</StyledTableCell>
                      <StyledTableCell align="center">STOCK TYPE</StyledTableCell>
                      <StyledTableCell align="center">ORDER TYPE</StyledTableCell>
                      <StyledTableCell align="center">MSN</StyledTableCell>
                      <StyledTableCell align="center">SUB-FAMILY NAME</StyledTableCell>
                      <StyledTableCell align="center">ITEM DESCRIPTION</StyledTableCell>
                      <StyledTableCell align="center">ITEM CODE</StyledTableCell>
                      <StyledTableCell align="center">MANUFACTURER PART NUMBER</StyledTableCell>
                      <StyledTableCell align="center">BRAND NAME</StyledTableCell>
                      <StyledTableCell align="center">STORAGE CODE</StyledTableCell>
                      <StyledTableCell align="center">PALLET CODE</StyledTableCell>
                      <StyledTableCell align="center">CURRENT CONDITION CODE</StyledTableCell>
                      <StyledTableCell align="center">GRADING SCALE</StyledTableCell>
                      <StyledTableCell align="center">ACTIVITY CODE</StyledTableCell>

                      <StyledTableCell align="center">DAMAGE CODE</StyledTableCell>
                      <StyledTableCell align="center">PACKAGING</StyledTableCell>
                      <StyledTableCell align="center">CONFIGURATION OS</StyledTableCell>
                      {itemFormFields?.map((i, index) => (
                        <StyledTableCell align="center" key={index}>
                          {i.inputLabel}
                        </StyledTableCell>
                      ))}

                      <StyledTableCell align="center"> INBOUND REMARKS</StyledTableCell>
                      <TableCell align="center" sx={{ minWidth: '80px' }}>
                        IMAGE
                      </TableCell>
                      <TableCell align="center">ACTION</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ minWidth: '80px' }} align="center">
                        1
                      </TableCell>
                      <StyledTableCell align="center">
                        {updateData?.itemCategory?.toUpperCase()}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{
                              '& .MuiInputBase-input': {
                                height: '8px',
                              },
                              marginTop: '16px',
                              width: '100%',
                            }}
                            name="expiryDate"
                            variant="outlined"
                            size="small"
                            label="Expiry Date"
                            slotProps={{
                              textField: {
                                InputLabelProps: { shrink: true },
                              },
                            }}
                            views={['year', 'month', 'day']}
                            format="DD-MM-YYYY"
                            value={updateData.expiryDate ? dayjs(updateData.expiryDate) : null}
                            onChange={e => handleChange(e)}
                          />
                        </LocalizationProvider>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={stockTypes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="stockType"
                          label="Stock Type"
                          value={updateData.stockType}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={orderTypeData.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="orderType"
                          label="Order Type"
                          value={updateData.orderType}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="msn"
                          value={updateData.msn}
                          label="MSN"
                          required={true}
                          disabled={!isSuper}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          onChange={e => handleChange(e)}
                          options={subFamilies.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="subFamily"
                          label="Sub-Family Name"
                          value={updateData.subFamily}
                          required={true}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          name="itemDescription"
                          value={updateData.itemDescription}
                          options={itemDescription.filter(
                            s => s.warehouse === updateData.warehouse
                          )}
                          label="Item Description"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="itemCode"
                          value={updateData.itemCode}
                          label="Item Code"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="manufacturerPartNumber"
                          value={updateData.manufacturerPartNumber}
                          label="Manufacturer Part Number"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={brandData.filter(s => s.warehouse?._id === updateData.warehouse)}
                          name="brandName"
                          label="Brand Name"
                          value={updateData.brandName}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={storageCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="storageCode"
                          label="Storage Code"
                          value={updateData.storageCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={palletCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="palletCode"
                          label="Pallet Code"
                          value={updateData.palletCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={currentConditionCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="conditionCode"
                          label="Current Condition Code"
                          value={updateData.conditionCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomSelect
                          options={gradingScale.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="gradingScale"
                          label="Grading Scale"
                          value={updateData.gradingScale}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          name="activityCode"
                          value={updateData.activityCode}
                          label="Activity Code"
                          required={true}
                          options={activityCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          disabled={
                            !gradingScale.find(g => g._id === updateData.gradingScale)?.isDamaged
                          }
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={damageCode.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="damageCode"
                          label="Damage Code"
                          value={updateData.damageCode}
                          required={true}
                          disabled={
                            !gradingScale
                              .filter(s => s.warehouse?._id === updateData.warehouse)
                              .find(g => g._id === updateData.gradingScale)?.isDamaged
                          }
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomSelect
                          options={packaging.filter(s => s.warehouse?._id === updateData.warehouse)}
                          name="packaging"
                          label="Packaging"
                          value={updateData.packaging}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="configurationOs"
                          value={updateData.configurationOs}
                          label="Configuration OS"
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      {itemFormFields?.map((f, index) => (
                        <StyledTableCell align="center" key={index}>
                          <CustomInput
                            onChange={e => handleCustomInputChangeItem(e)}
                            name={f.inputLabel}
                            value={
                              updateData.meta?.find(ff => ff.inputLabel === f.inputLabel)?.value ||
                              ''
                            }
                            required={f.isRequired}
                            label={f.inputLabel}
                            type={f.inputType}
                          />
                        </StyledTableCell>
                      ))}
                      <StyledTableCell align="center">
                        <CustomInput
                          name="remarks"
                          value={updateData.remarks}
                          label="Inbound Remarks"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <TableCell align="center" sx={{ minWidth: '80px' }}>
                        <ShowComponent module={'Item History'} action={'view'}>
                          <ViewOrUpdateItemFiles
                            key={updateData._id}
                            module={'Item History'}
                            item={updateData}
                            onUpdate={onUpdateItem}
                          />
                        </ShowComponent>
                      </TableCell>

                      <StyledTableCell align="center">
                        <ShowComponent module={'Item History'} action={'update'}>
                          <LoadingButton
                            loading={loadingSave}
                            size="small"
                            variant="contained"
                            onClick={() => handleUpdate(updateData._id, updateData)}
                          >
                            Save
                          </LoadingButton>
                        </ShowComponent>
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : null}
          {updateData.itemCategory?.toLowerCase() === 'new' ? (
            <>
              {' '}
              <TableContainer component={Paper}>
                <Table>
                  <TableHead
                    sx={{
                      backgroundColor: theme =>
                        theme.palette.mode === 'dark'
                          ? theme.palette.primary.dark
                          : theme.palette.primary.light,
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ minWidth: '80px' }} align="center">
                        S.NO
                      </TableCell>
                      <StyledTableCell align="center">ITEM CATEGORY</StyledTableCell>

                      <StyledTableCell align="center">EXPIRY DATE</StyledTableCell>
                      <StyledTableCell align="center">STOCK TYPE</StyledTableCell>
                      <StyledTableCell align="center">ORDER TYPE</StyledTableCell>
                      <StyledTableCell align="center">MSN</StyledTableCell>
                      <StyledTableCell align="center">SUB-FAMILY NAME</StyledTableCell>
                      <StyledTableCell align="center">ITEM DESCRIPTION</StyledTableCell>
                      <StyledTableCell align="center">ITEM CODE</StyledTableCell>
                      <StyledTableCell align="center">MANUFACTURER PART NUMBER</StyledTableCell>
                      <StyledTableCell align="center">BRAND NAME</StyledTableCell>
                      <StyledTableCell align="center">STORAGE CODE</StyledTableCell>
                      <StyledTableCell align="center">PALLET CODE</StyledTableCell>
                      <StyledTableCell align="center">CURRENT CONDITION CODE</StyledTableCell>
                      <StyledTableCell align="center">CONFIGURATION OS</StyledTableCell>
                      {itemFormFields?.map((i, index) => (
                        <StyledTableCell align="center" key={index}>
                          {i.inputLabel}
                        </StyledTableCell>
                      ))}

                      <StyledTableCell align="center"> INBOUND REMARKS</StyledTableCell>
                      <TableCell align="center" sx={{ minWidth: '80px' }}>
                        IMAGE
                      </TableCell>
                      <TableCell align="center">ACTION</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ minWidth: '80px' }} align="center">
                        1
                      </TableCell>

                      <StyledTableCell align="center">
                        {updateData.itemCategory?.toUpperCase()}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{
                              '& .MuiInputBase-input': {
                                height: '8px',
                              },
                              marginTop: '16px',
                              width: '100%',
                            }}
                            name="expiryDate"
                            variant="outlined"
                            size="small"
                            label="Expiry Date"
                            slotProps={{
                              textField: {
                                InputLabelProps: { shrink: true },
                              },
                            }}
                            views={['year', 'month', 'day']}
                            format="DD-MM-YYYY"
                            value={updateData.expiryDate ? dayjs(updateData.expiryDate) : null}
                            onChange={e => handleChange(e)}
                          />
                        </LocalizationProvider>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={stockTypes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="stockType"
                          label="Stock Type"
                          value={updateData.stockType}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={orderTypeData.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="orderType"
                          label="Order Type"
                          value={updateData.orderType}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="msn"
                          value={updateData.msn}
                          label="MSN"
                          required={true}
                          disabled={!isSuper}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          onChange={e => handleChange(e)}
                          options={subFamilies.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="subFamily"
                          label="Sub-Family Name"
                          value={updateData.subFamily}
                          required={true}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          name="itemDescription"
                          value={updateData.itemDescription}
                          options={itemDescription.filter(
                            s => s.warehouse === updateData.warehouse
                          )}
                          label="Item Description"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="itemCode"
                          value={updateData.itemCode}
                          label="Item Code"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="manufacturerPartNumber"
                          value={updateData.manufacturerPartNumber}
                          label="Manufacturer Part Number"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={brandData.filter(s => s.warehouse?._id === updateData.warehouse)}
                          name="brandName"
                          label="Brand Name"
                          value={updateData.brandName}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={storageCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="storageCode"
                          label="Storage Code"
                          value={updateData.storageCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={palletCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="palletCode"
                          label="Pallet Code"
                          value={updateData.palletCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={currentConditionCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="conditionCode"
                          label="Current Condition Code"
                          value={updateData.conditionCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomInput
                          name="configurationOs"
                          value={updateData.configurationOs}
                          label="Configuration OS"
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      {itemFormFields?.map((f, index) => (
                        <StyledTableCell align="center" key={index}>
                          <CustomInput
                            onChange={e => handleCustomInputChangeItem(e)}
                            name={f.inputLabel}
                            value={
                              updateData.meta?.find(ff => ff.inputLabel === f.inputLabel)?.value ||
                              ''
                            }
                            required={f.isRequired}
                            label={f.inputLabel}
                            type={f.inputType}
                          />
                        </StyledTableCell>
                      ))}

                      <StyledTableCell align="center">
                        <CustomInput
                          name="remarks"
                          value={updateData.remarks}
                          label="Inbound Remarks"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <TableCell align="center">
                        <ShowComponent module={'Item History'} action={'view'}>
                          <ViewOrUpdateItemFiles
                            key={updateData._id}
                            module={'Item History'}
                            item={updateData}
                            onUpdate={onUpdateItem}
                          />
                        </ShowComponent>
                      </TableCell>
                      <StyledTableCell align="center">
                        <ShowComponent module={'Item History'} action={'update'}>
                          <LoadingButton
                            loading={loadingSave}
                            size="small"
                            variant="contained"
                            onClick={() => handleUpdate(updateData._id, updateData)}
                          >
                            Save
                          </LoadingButton>
                        </ShowComponent>
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : null}
          {updateData.itemCategory?.toLowerCase() === 'faulty' ? (
            <>
              {' '}
              <TableContainer component={Paper}>
                <Table>
                  <TableHead
                    sx={{
                      backgroundColor: theme =>
                        theme.palette.mode === 'dark'
                          ? theme.palette.primary.dark
                          : theme.palette.primary.light,
                    }}
                  >
                    <TableRow>
                      <TableCell sx={{ minWidth: '80px' }} align="center">
                        S.NO
                      </TableCell>
                      <StyledTableCell align="center">ITEM CATEGORY</StyledTableCell>
                      <StyledTableCell align="center">EXPIRY DATE</StyledTableCell>
                      <StyledTableCell align="center">STOCK TYPE</StyledTableCell>
                      <StyledTableCell align="center">ORDER TYPE</StyledTableCell>
                      <StyledTableCell align="center">MSN</StyledTableCell>
                      <StyledTableCell align="center">SUB-FAMILY NAME</StyledTableCell>
                      <StyledTableCell align="center">ITEM DESCRIPTION</StyledTableCell>
                      <StyledTableCell align="center">ITEM CODE</StyledTableCell>
                      <StyledTableCell align="center">MANUFACTURER PART NUMBER</StyledTableCell>
                      <StyledTableCell align="center">BRAND NAME</StyledTableCell>
                      <StyledTableCell align="center">STORAGE CODE</StyledTableCell>
                      <StyledTableCell align="center">PALLET CODE</StyledTableCell>
                      <StyledTableCell align="center">CURRENT CONDITION CODE</StyledTableCell>
                      <StyledTableCell align="center">GRADING SCALE</StyledTableCell>
                      <StyledTableCell align="center">ACTIVITY CODE</StyledTableCell>

                      <StyledTableCell align="center">DAMAGE CODE</StyledTableCell>
                      <StyledTableCell align="center">PACKAGING</StyledTableCell>
                      <StyledTableCell align="center">CONFIGURATION OS</StyledTableCell>
                      {itemFormFields?.map((i, index) => (
                        <StyledTableCell align="center" key={index}>
                          {i.inputLabel}
                        </StyledTableCell>
                      ))}
                      <StyledTableCell align="center">OEM_CASE_NUMBER</StyledTableCell>
                      <StyledTableCell align="center">OEM_SUPPORT_REMARKS</StyledTableCell>
                      <StyledTableCell align="center">RMA_ACTIVITY_WH_REMARKS</StyledTableCell>
                      <StyledTableCell align="center">RMA_ACTIVITY_WH_REMARKS1</StyledTableCell>
                      <StyledTableCell align="center">RMA_ACTIVITY_WH_REMARKS2</StyledTableCell>
                      <StyledTableCell align="center">CALL_LOG_DATE</StyledTableCell>
                      <StyledTableCell align="center">OEM_REPAIR_DATE</StyledTableCell>
                      <StyledTableCell align="center">SERVICE_REPORT_RECEIVED_DATE</StyledTableCell>
                      <StyledTableCell align="center">QUOTATION_RECEIVED_DATE</StyledTableCell>

                      <StyledTableCell align="center"> INBOUND REMARKS</StyledTableCell>
                      <TableCell align="center" sx={{ minWidth: '80px' }}>
                        IMAGE
                      </TableCell>
                      <TableCell align="center">ACTION</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ minWidth: '80px' }} align="center">
                        1
                      </TableCell>
                      <StyledTableCell align="center">
                        {updateData?.itemCategory?.toUpperCase()}
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{
                              '& .MuiInputBase-input': {
                                height: '8px',
                              },
                              marginTop: '16px',
                              width: '100%',
                            }}
                            name="expiryDate"
                            variant="outlined"
                            size="small"
                            label="Expiry Date"
                            slotProps={{
                              textField: {
                                InputLabelProps: { shrink: true },
                              },
                            }}
                            views={['year', 'month', 'day']}
                            format="DD-MM-YYYY"
                            value={updateData.expiryDate ? dayjs(updateData.expiryDate) : null}
                            onChange={e => handleChange(e)}
                          />
                        </LocalizationProvider>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={stockTypes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="stockType"
                          label="Stock Type"
                          value={updateData.stockType}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={orderTypeData.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="orderType"
                          label="Order Type"
                          value={updateData.orderType}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="msn"
                          value={updateData.msn}
                          label="MSN"
                          required={true}
                          disabled={!isSuper}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          onChange={e => handleChange(e)}
                          options={subFamilies.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="subFamily"
                          label="Sub-Family Name"
                          value={updateData.subFamily}
                          required={true}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          name="itemDescription"
                          value={updateData.itemDescription}
                          options={itemDescription.filter(
                            s => s.warehouse === updateData.warehouse
                          )}
                          label="Item Description"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="itemCode"
                          value={updateData.itemCode}
                          label="Item Code"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="manufacturerPartNumber"
                          value={updateData.manufacturerPartNumber}
                          label="Manufacturer Part Number"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={brandData.filter(s => s.warehouse?._id === updateData.warehouse)}
                          name="brandName"
                          label="Brand Name"
                          value={updateData.brandName}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={storageCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="storageCode"
                          label="Storage Code"
                          value={updateData.storageCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={palletCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="palletCode"
                          label="Pallet Code"
                          value={updateData.palletCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={currentConditionCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="conditionCode"
                          label="Current Condition Code"
                          value={updateData.conditionCode}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomSelect
                          options={gradingScale.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="gradingScale"
                          label="Grading Scale"
                          value={updateData.gradingScale}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          name="activityCode"
                          value={updateData.activityCode}
                          label="Activity Code"
                          required={true}
                          options={activityCodes.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          disabled={
                            !gradingScale.find(g => g._id === updateData.gradingScale)?.isDamaged
                          }
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomSelect
                          options={damageCode.filter(
                            s => s.warehouse?._id === updateData.warehouse
                          )}
                          name="damageCode"
                          label="Damage Code"
                          value={updateData.damageCode}
                          required={true}
                          disabled={
                            !gradingScale
                              .filter(s => s.warehouse?._id === updateData.warehouse)
                              .find(g => g._id === updateData.gradingScale)?.isDamaged
                          }
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomSelect
                          options={packaging.filter(s => s.warehouse?._id === updateData.warehouse)}
                          name="packaging"
                          label="Packaging"
                          value={updateData.packaging}
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="configurationOs"
                          value={updateData.configurationOs}
                          label="Configuration OS"
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      {itemFormFields?.map((f, index) => (
                        <StyledTableCell align="center" key={index}>
                          <CustomInput
                            onChange={e => handleCustomInputChangeItem(e)}
                            name={f.inputLabel}
                            value={
                              updateData.meta?.find(ff => ff.inputLabel === f.inputLabel)?.value ||
                              ''
                            }
                            required={f.isRequired}
                            label={f.inputLabel}
                            type={f.inputType}
                          />
                        </StyledTableCell>
                      ))}
                      <StyledTableCell align="center">
                        <CustomInput
                          name="oemCaseNumber"
                          value={updateData.oemCaseNumber}
                          label="OEM_CASE_NUMBER"
                          required={false}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomInput
                          name="oemSupportRemarks"
                          value={updateData.oemSupportRemarks}
                          label="OEM_SUPPORT_REMARKS"
                          required={false}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="warehouseRemarks"
                          value={updateData.warehouseRemarks}
                          label="RMA_ACTIVITY_WH_REMARKS"
                          required={false}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>

                      <StyledTableCell align="center">
                        <CustomInput
                          name="rmaActivityWhRemarks1"
                          value={updateData.rmaActivityWhRemarks1}
                          label="RMA_ACTIVITY_WH_REMARKS1"
                          required={false}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="rmaActivityWhRemarks2"
                          value={updateData.rmaActivityWhRemarks2}
                          label="RMA_ACTIVITY_WH_REMARKS2"
                          required={false}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ '& .MuiInputBase-input': { height: '8px' }, marginTop: '16px', width: '100%' }}
                            label="Call Log Date"
                            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                            views={['year', 'month', 'day']}
                            format="DD-MM-YYYY"
                            value={updateData.callLogDate ? dayjs(updateData.callLogDate) : null}
                            onChange={e => handleChange(e, 'callLogDate')}
                          />
                        </LocalizationProvider>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ '& .MuiInputBase-input': { height: '8px' }, marginTop: '16px', width: '100%' }}
                            label="OEM Repair Date"
                            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                            views={['year', 'month', 'day']}
                            format="DD-MM-YYYY"
                            value={updateData.oemRepairDate ? dayjs(updateData.oemRepairDate) : null}
                            onChange={e => handleChange(e, 'oemRepairDate')}
                          />
                        </LocalizationProvider>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ '& .MuiInputBase-input': { height: '8px' }, marginTop: '16px', width: '100%' }}
                            label="Service Report Received Date"
                            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                            views={['year', 'month', 'day']}
                            format="DD-MM-YYYY"
                            value={updateData.serviceReportReceivedDate ? dayjs(updateData.serviceReportReceivedDate) : null}
                            onChange={e => handleChange(e, 'serviceReportReceivedDate')}
                          />
                        </LocalizationProvider>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            sx={{ '& .MuiInputBase-input': { height: '8px' }, marginTop: '16px', width: '100%' }}
                            label="Quotation Received Date"
                            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
                            views={['year', 'month', 'day']}
                            format="DD-MM-YYYY"
                            value={updateData.quotationReceivedDate ? dayjs(updateData.quotationReceivedDate) : null}
                            onChange={e => handleChange(e, 'quotationReceivedDate')}
                          />
                        </LocalizationProvider>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <CustomInput
                          name="remarks"
                          value={updateData.remarks}
                          label="Inbound Remarks"
                          required={true}
                          onChange={e => handleChange(e)}
                        />
                      </StyledTableCell>
                      <TableCell align="center" sx={{ minWidth: '80px' }}>
                        <ShowComponent module={'Item History'} action={'view'}>
                          <ViewOrUpdateItemFiles
                            key={updateData._id}
                            module={'Item History'}
                            item={updateData}
                            onUpdate={onUpdateItem}
                          />
                        </ShowComponent>
                      </TableCell>

                      <StyledTableCell align="center">
                        <ShowComponent module={'Item History'} action={'update'}>
                          <LoadingButton
                            loading={loadingSave}
                            size="small"
                            variant="contained"
                            onClick={() => handleUpdate(updateData._id, updateData)}
                          >
                            Save
                          </LoadingButton>
                        </ShowComponent>
                      </StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : null}
        </>
      ) : null}

      {formData.length ? (
        <>
          <Typography component="h1" sx={{ fontWeight: 'bold', mt: 3, mb: 2 }}>
            Item History Details
          </Typography>
          <StyledTableContainer component={Paper}>
            <Table stickyHeader>
              <StyledTableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      minWidth: '80px',
                      position: 'sticky',
                      left: 0,
                      zIndex: 2,
                      backgroundColor: theme =>
                        theme.palette.mode === 'dark'
                          ? theme.palette.primary.dark
                          : theme.palette.primary.light,
                    }}
                    align="center"
                  >
                    S.No
                  </TableCell>
                  <StyledTableCell align="center">GMS REFERENCE CODE</StyledTableCell>
                  <StyledTableCell align="center">ITEM CATEGORY</StyledTableCell>
                  <StyledTableCell align="center">EXPIRY DATE</StyledTableCell>
                  <StyledTableCell align="center">STOCK TYPE</StyledTableCell>
                  <StyledTableCell align="center">ORDER TYPE</StyledTableCell>
                  <StyledTableCell align="center">MSN</StyledTableCell>
                  <StyledTableCell align="center">SUB-FAMILY NAME</StyledTableCell>
                  <StyledTableCell align="center">ITEM DESCRIPTION</StyledTableCell>
                  <StyledTableCell align="center">ITEM CODE</StyledTableCell>
                  <StyledTableCell align="center">MANUFACTURER PART NUMBER</StyledTableCell>
                  <StyledTableCell align="center">ACTIVITY CODE</StyledTableCell>
                  <StyledTableCell align="center">DAMAGE CODE</StyledTableCell>
                  <StyledTableCell align="center">GRADING SCALE</StyledTableCell>
                  <StyledTableCell align="center">BRAND NAME</StyledTableCell>
                  <StyledTableCell align="center">STORAGE CODE</StyledTableCell>
                  <StyledTableCell align="center">PALLET CODE</StyledTableCell>
                  <StyledTableCell align="center">PACKAGING</StyledTableCell>
                  <StyledTableCell align="center">CURRENT CONDITION CODE</StyledTableCell>
                  <StyledTableCell align="center">CONFIGURATION OS</StyledTableCell>
                  <StyledTableCell align="center">ON HOLD</StyledTableCell>
                  <StyledTableCell align="center">ON HOLD REMARKS</StyledTableCell>
                  <StyledTableCell align="center">IN BUNDLE</StyledTableCell>
                  <StyledTableCell align="center">IN STOCK</StyledTableCell>
                  <StyledTableCell align="center">IS SAVED</StyledTableCell>
                  {itemFormFields?.map((i, index) => (
                    <StyledTableCell align="center" key={index}>
                      {i.inputLabel}
                    </StyledTableCell>
                  ))}
                  <StyledTableCell align="center">OEM_CASE_NUMBER</StyledTableCell>
                  <StyledTableCell align="center">OEM_SUPPORT_REMARKS</StyledTableCell>
                  <StyledTableCell align="center">RMA_ACTIVITY_WH_REMARKS</StyledTableCell>
                  <StyledTableCell align="center">RMA_ACTIVITY_WH_REMARKS1</StyledTableCell>
                  <StyledTableCell align="center">RMA_ACTIVITY_WH_REMARKS2</StyledTableCell>
                  <StyledTableCell align="center">CALL_LOG_DATE</StyledTableCell>
                  <StyledTableCell align="center">OEM_REPAIR_DATE</StyledTableCell>
                  <StyledTableCell align="center">SERVICE_REPORT_RECEIVED_DATE</StyledTableCell>
                  <StyledTableCell align="center">QUOTATION_RECEIVED_DATE</StyledTableCell>
                  <StyledTableCell align="center">INBOUND REMARKS</StyledTableCell>
                  <StyledTableCell align="center">IMAGE</StyledTableCell>
                  <StyledTableCell align="center">ENTRY DATE</StyledTableCell>
                  <StyledTableCell align="center">UPDATED DATE</StyledTableCell>
                  <StyledTableCell align="center">UPDATED BY</StyledTableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {formData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, i) => (
                    <StyledTableRow key={i}>
                      <TableCell
                        align="center"
                        sx={{
                          minWidth: '80px',
                          position: 'sticky',
                          left: 0,
                          zIndex: 1,
                          backgroundColor: theme => theme.palette.background.paper,
                        }}
                      >
                        {page * rowsPerPage + 1 + i}
                      </TableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.gmsReferenceCode?.isModified)}
                      >
                        {row?.gmsReferenceCode?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.itemCategory?.isModified)}
                      >
                        {row?.itemCategory?.value.toUpperCase()}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.expiryDate?.isModified)}
                      >
                        {!row?.expiryDate?.value?.includes('Previous')
                          ? row.expiryDate?.value !== 'null' && row.expiryDate?.value !== null
                            ? dayjs(new Date(row.expiryDate?.value)).format('DD/MM/YYYY')
                            : 'N/A'
                          : row.expiryDate.value}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.stockType?.isModified)}
                      >
                        {row?.stockType?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.orderType?.isModified)}
                      >
                        {row?.orderType?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell align="center" sx={getModifiedStyles(row.msn?.isModified)}>
                        {row?.msn?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.subFamily?.isModified)}
                      >
                        {row?.subFamily?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.itemDescription?.isModified)}
                      >
                        {row?.itemDescription?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.itemCode?.isModified)}
                      >
                        {row?.itemCode?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.manufacturerPartNumber?.isModified)}
                      >
                        {row?.manufacturerPartNumber?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.activityCode?.isModified)}
                      >
                        {row?.activityCode?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.damageCode?.isModified)}
                      >
                        {row?.damageCode?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.gradingScale?.isModified)}
                      >
                        {row?.gradingScale?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.brandName?.isModified)}
                      >
                        {row?.brandName?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.storageCode?.isModified)}
                      >
                        {row?.storageCode?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.palletCode?.isModified)}
                      >
                        {row?.palletCode?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.packaging?.isModified)}
                      >
                        {row?.packaging?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.conditionCode?.isModified)}
                      >
                        {row?.conditionCode?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.configurationOs?.isModified)}
                      >
                        {row?.configurationOs?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.freezed?.isModified)}
                      >
                        {row?.freezed?.value?.toString()}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.freezeRemarks?.isModified)}
                      >
                        {row?.freezeRemarks?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.inBundle?.isModified)}
                      >
                        {row?.inBundle?.value.toString()}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.inStock?.isModified)}
                      >
                        {row?.inStock?.value.toString()}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.isSaved?.isModified)}
                      >
                        {row?.isSaved?.value.toString()}
                      </StyledTableCell>
                      {itemFormFields?.map((f, index) => {
                        const value = row[f.inputLabel];

                        return (
                          <StyledTableCell
                            align="center"
                            key={index?.toString() + f.inputLabel}
                            sx={getModifiedStyles(value?.isModified)}
                          >
                            {typeof value === 'object' ? value?.value || 'N/A' : value || 'N/A'}
                          </StyledTableCell>
                        );
                      })}
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.oemCaseNumber?.isModified)}
                      >
                        {row?.oemCaseNumber?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.oemSupportRemarks?.isModified)}
                      >
                        {row?.oemSupportRemarks?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.warehouseRemarks?.isModified)}
                      >
                        {row?.warehouseRemarks?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.rmaActivityWhRemarks1?.isModified)}
                      >
                        {row?.rmaActivityWhRemarks1?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.rmaActivityWhRemarks2?.isModified)}
                      >
                        {row?.rmaActivityWhRemarks2?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.callLogDate?.isModified)}
                      >
                        {!row?.callLogDate?.value?.toString().includes('Previous')
                          ? row.callLogDate?.value && row.callLogDate?.value !== 'null'
                            ? dayjs(row.callLogDate.value).format('DD-MM-YYYY')
                            : 'N/A'
                          : row.callLogDate.value}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.oemRepairDate?.isModified)}
                      >
                        {!row?.oemRepairDate?.value?.toString().includes('Previous')
                          ? row.oemRepairDate?.value && row.oemRepairDate?.value !== 'null'
                            ? dayjs(row.oemRepairDate.value).format('DD-MM-YYYY')
                            : 'N/A'
                          : row.oemRepairDate.value}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.serviceReportReceivedDate?.isModified)}
                      >
                        {!row?.serviceReportReceivedDate?.value?.toString().includes('Previous')
                          ? row.serviceReportReceivedDate?.value && row.serviceReportReceivedDate?.value !== 'null'
                            ? dayjs(row.serviceReportReceivedDate.value).format('DD-MM-YYYY')
                            : 'N/A'
                          : row.serviceReportReceivedDate.value}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.quotationReceivedDate?.isModified)}
                      >
                        {!row?.quotationReceivedDate?.value?.toString().includes('Previous')
                          ? row.quotationReceivedDate?.value && row.quotationReceivedDate?.value !== 'null'
                            ? dayjs(row.quotationReceivedDate.value).format('DD-MM-YYYY')
                            : 'N/A'
                          : row.quotationReceivedDate.value}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.remarks?.isModified)}
                      >
                        {row?.remarks?.value || 'N/A'}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        sx={getModifiedStyles(row.images?.isModified)}
                      >
                        <Tooltip title="View">
                          <IconButton size="small" onClick={() => handleOpen(row?.images)}>
                            <RemoveRedEyeRoundedIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </StyledTableCell>
                      <StyledTableCell
                        sx={getModifiedStyles(row.enteredAt?.isModified)}
                        align="center"
                      >
                        {row.enteredAt?.value}
                      </StyledTableCell>
                      <StyledTableCell align="center">{row.updatedAt}</StyledTableCell>
                      <StyledTableCell align="center">{row.updatedBy}</StyledTableCell>
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </>
      ) : null}

      {formData.length ? (
        <TablePagination
          fullWidth
          component="div"
          count={formData ? (formData.length ? formData.length : 0) : 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={ROWS_PER_PAGE}
        />
      ) : null}

      <CustomDialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogTitle
          sx={{
            fontSize: '15px',
          }}
        >
          View Images
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 12,
            top: 8,
          }}
        >
          <Close />
        </IconButton>

        <Divider sx={{ mb: 2 }} />

        <DialogContent>
          <Typography mb={2} fontWeight={600}>
            Is the image modified?: {isModifiedImage ? 'Yes' : 'No'}
          </Typography>
          <Grid container spacing={1}>
            {images?.length === 0 ? (
              <Grid item xs={12}>
                <Typography align="center">No data available at the moment</Typography>
              </Grid>
            ) : (
              images?.map((image, index) => {
                const { date, filename } = extractFileInfo(image);
                return (
                  <Grid item xs={12} sm={12} md={12} key={index}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '8px',
                        borderRadius: '5px',
                        marginTop: '5px',
                        background: '#5fa5f661',
                      }}
                    >
                      <Box sx={{ flex: 1, mr: 2 }}>
                        <Typography variant="subtitle2" sx={{ wordBreak: 'break-all' }}>
                          {`File ${index + 1}: ${filename}`}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Added on: {date}
                        </Typography>
                      </Box>
                      <Stack direction="row" spacing={2}>
                        <IconButton onClick={() => window.open(image, '_blank')}>
                          <RemoveRedEyeRoundedIcon fontSize="small" />
                        </IconButton>
                      </Stack>
                    </Box>
                  </Grid>
                );
              })
            )}
          </Grid>
          <Box sx={{ textAlign: 'right', mt: 2 }}>
            <Button size="small" onClick={handleClose} variant="contained" color="error">
              Cancel
            </Button>
          </Box>
        </DialogContent>
      </CustomDialog>
    </>
  );
}
